export const json = [
  {
    class: 'cancer-cause',
    text: 'Medical',
    link: '/cause/medical-fundraising',
    outer: false
  },
  {
    class: 'acci-cause',
    text: 'Memorial',
    link: '/cause/memorial-fundraising',
    outer: false
  },
  {
    class: 'liver-cause',
    text: 'Children',
    link: '/cause/help-children',
    outer: false
  },
  {
    class: 'heart-cause',
    text: 'Education',
    link: '/cause/fundraising-for-education',
    outer: false
  },
  {
    class: 'kidney-cause',
    text: 'Animal',
    link: '/cause/animal-fundraising',
    outer: false
  },
  {
    class: 'child-cause',
    text: 'Others',
    link: '/crowdfunding/fundraisers',
    outer: false
  }
];
